import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import voucher_intregaion_image from '../../../../../assets/voucher_intregaion_image.png';
import aiva_appearance from '../../../../../assets/aiva_appearance.jpg';
import aiva_nudges from '../../../../../assets/aiva_nudges.jpg';
import DigitalAssistant from './DigitalAssistant';
import IntegrationInfo from './IntegrationInfo';
import NudgesSetting from './NudgesSetting';
import MultliLanguages from './MultliLanguages';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  putAPI_Update_Ingetration,
  gAPI_Ingetration,
  gAPI_Property_List,
  dAPI_Delete_Ingetration,
  gAPI_Vouchers_List,
  gAPI_MembershipTags
} from '../../../../../constants/APIs';
import CodeSnippet from './CodeSnippet';
import { NavLink } from 'react-router-dom';
import { faHandSpock } from '@fortawesome/free-regular-svg-icons';
import {
  faPalette,
  faLanguage,
  faFont,
  faLocationArrow,
} from '@fortawesome/free-solid-svg-icons';

import { faWpforms } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BubblePosition from './BubblePosition';
import Example from './Example';
import VoucherCodeSnippet from './VoucherCodeSnippet';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CustomFonts from './CustomFonts';
import CustomEmails from './customEmails';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import AivaAppearanceImage from '../../../../../assets/aiva_appearance_image.png';
import AivaEmailImage from '../../../../../assets/aiva_email_image.png';
import AivaLayoutImage from '../../../../../assets/aiva_layout_image.png';
import AivaSocialImage from '../../../../../assets/aiva_social_image.png';
import AivaFeaturesImage from '../../../../../assets/aiva_features_image.png';
function Voucher({ match, history,email,propertyId,locale }) {
  const integrationId = match.params.id;
  const [integration, setIntegration] = useState();
  const [fontsVisible, setFontsVisible] = useState(false);
  const [allProperties, setAllProperties] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [apperanceVisible, setApperanceVisible] = useState(false);
  const [nudgesVisible, setNudgesVisible] = useState(false);
  const [positionVisible, setPositionVisible] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [emailVisible, setEmailVisible] = useState(false);
  const [languageVisible, setLanguageVisible] = useState(false);
  const [publishVisible, setPublishVisible] = useState(false);
  const [showVoucherList, setShowVoucherList] = useState([]);
  const [membershipTags,setMembershipTags]=useState([]);
  //console.log(integrationId);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };

  const property = () => {
    setFontsVisible(false);
    setPropertyVisible(true);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setEmailVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
  };

const emails = () => {
  setFontsVisible(false);
  setPropertyVisible(false);
  setEmailVisible(true);
  setApperanceVisible(false);
  setNudgesVisible(false);
  setPositionVisible(false);
  setFormVisible(false);
  setLanguageVisible(false);
  setPublishVisible(false);
};

  const appearance = () => {
    setPropertyVisible(false);
    setFontsVisible(false);
    setApperanceVisible(true);
    setEmailVisible(false);
    setEmailVisible(false);
    setNudgesVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
  };

  const nudges = () => {
    setPropertyVisible(false);
    setFontsVisible(false);
    setApperanceVisible(false);
    setEmailVisible(false);
    setNudgesVisible(true);
    setPositionVisible(false);
    setEmailVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Vouchers_List}?groupId=${getGroupID()}&propertyId=${propertyId}&languageCode=${locale}&search=&status=Active
        &pageNumber=1&pageSize=10000&email=${email}`,
    })
      .then((res) => {
        setShowVoucherList(res.data.vouchers);       
      })
      .catch((err) => null);
  };

  const publishCode = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setFontsVisible(false);
    setEmailVisible(false);
    setPositionVisible(false);
    setEmailVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(true);
  };
  const setPosition = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setEmailVisible(false);
    setFontsVisible(false);
    setPositionVisible(true);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
  };
  const setLanguage = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setFontsVisible(false);
    setEmailVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(true);
    setPublishVisible(false);
  };
  const setFonts = () => {
    setPropertyVisible(false);
    setApperanceVisible(false);
    setNudgesVisible(false);
    setFontsVisible(true);
    setEmailVisible(false);
    setPositionVisible(false);
    setFormVisible(false);
    setLanguageVisible(false);
    setPublishVisible(false);
  };

  useEffect(() => {
    // console.log(integrationId);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_MembershipTags}?propertyId=${propertyId}`,
    })
      .then((res) => {        
        if(res.data!== undefined && res.data.tags !== undefined)
           setMembershipTags(res.data.tags);
        setPropertyVisible(true);
    }); 
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Ingetration}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        // console.log(res.data);
        setIntegration(res.data);
      })
      .catch((err) => console.log('err', err));
    }, [integrationId]);

    useEffect(() => {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
      }).then((res) => {
        setAllProperties(res.data);
      });
    }, []);

  const saveIntegration = (data) => {
    const { list, name, botSetting,isAivaHide,isShowMembership,selectedMemberShipTags } = data;
    if(data.PageSettings !== undefined)
      {        
        updateModel.botSettings = botSetting;
      }
    if (botSetting) {
      updateModel.botSettings = botSetting;
    }
    if (list) {
      updateModel.properties = list;      
      updateModel.ismembership=isShowMembership;
      updateModel.MembershipTags=selectedMemberShipTags.map((m)=>m.value);
    }
    if (name) {
      console.log(isShowMembership,selectedMemberShipTags);
      updateModel.name = name;
      updateModel.ismembership=isShowMembership;
      updateModel.MembershipTags=selectedMemberShipTags.map((m)=>m.value);
    }

    if (data.isaivaHide !== undefined) {
       updateModel.isaivaHide = data.isaivaHide;
       updateModel.applyPromoCode = data.applyPromoCode;
       
    }
    
    console.log('update', updateModel);

    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Ingetration}/voucher/${integration.id
        }?group_id=${getGroupID()}`,
      data: updateModel,
    })
      .catch((err) => console.error(err))
      .then(()=>{
        NotificationManager.success(
          "",
          "Integration updated successfully",
          3000,
          null,
          null,
          "success"
        );
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
  };

  const RedirectToDemo = () => {
    var url = `${process.env.REACT_APP_VOUCHER_BOT_DEMO
      }?gid=${getGroupID()}&iid=${integrationId}`;
    window.open(url, '_blank');
  };

  const modelNudges =
    integration && integration.channelDetails !== null
      ? integration.channelDetails.initiationRuleset[0].nudges.map((nudge) => {
        if (nudge.eyeCatcher && nudge.greeting) {
          return {
            eyeCatcher: {
              code: nudge.eyeCatcher.query.code,
              filterTags: null,
            },
            greeting: {
              code: nudge.greeting.query.code,
              filterTags: null,
            },
            delayInMilliseconds: nudge.delayInMilliseconds,
            buttons: nudge.buttons,
          };
        }
      })
      : null;

  const updateModel = integration
    ? {
      name: integration.name,
      level: integration.level,
      properties: [...integration.properties],
      sessionTimeoutInSeconds: integration.sessionTimeoutInSeconds,
      baseUrl:
        integration.channelDetails !== null
          ? integration.channelDetails.baseUrl
          : '',
      homePageRoute:
        integration.channelDetails !== null
          ? integration.channelDetails.homePageRoute
          : '',
      defaultLanguage: 'en-US',
      defaultRuleDescription: 'Default',
      defaultRuleNudges: modelNudges !== null ? [...modelNudges] : '',
      botSettings: { ...integration.botSettings },
    }
    : null;

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  /** FIXME: */
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integrationId}/?group_id=${getGroupID()}`,
    })
      .then((res) => console.log('res', res))
      .then(
        setTimeout(() => {
          history.push('/app/pages/integration');
        }, 300)
      );
  };

  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                             Select Businesses  
                          </p>
                          <p className="mb-4 text-small">
                             Select the businesses that are visible through this voucher store
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${apperanceVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faPalette} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => appearance()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                        <p className="list-item-heading mb-1 color-theme-1">
                            Appearance
                          </p>
                          <p className="mb-4 text-small">
                            Choose the icon to display on your website
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${nudgesVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faHandSpock} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => nudges()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                        <p className="list-item-heading mb-1  color-theme-1">
                            Nudges
                          </p>
                          <p className="mb-4 text-small">
                            Setup proactive messages to engage the website visitors
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${positionVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLocationArrow} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setPosition()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                        <p className="list-item-heading mb-1 color-theme-1">
                            Position
                          </p>
                          <p className="mb-4 text-small">
                          Control the position of the Vouchers icon on your website
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration d-none ${languageVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLanguage} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setLanguage()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                        <p className="list-item-heading mb-1 color-theme-1">
                            Language
                          </p>
                          <p className="mb-4 text-small">
                            Select the languages for the chat widget
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${emailVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLanguage} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => emails()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                        <p className="list-item-heading mb-1 color-theme-1">
                            Custom Emails
                          </p>
                          <p className="mb-4 text-small">
                            Select the languages for the chat widget
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${fontsVisible ==true ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faFont} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => setFonts()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                        <p className="list-item-heading mb-1 color-theme-1">
                            Custom Fonts
                          </p>
                          <p className="mb-4 text-small">
                            Control the fonts of aiva widget on your website
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  
                  <div
                    className={`mb-3 integration ${publishVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-monitor---tablet`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => publishCode()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                             Publish to your website
                          </p>
                          <p className="mb-4 text-small">
                             Copy the code snippet to install your Voucher plug-in
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={RedirectToDemo}
                    >
                      Preview
                    </Button>

                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {propertyVisible && (
                <Fragment>
                  <IntegrationInfo
                    membership={membershipTags}
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />                                   
                </Fragment>
              )}
              {emailVisible && (
                <Fragment>
                  <CustomEmails
                    integration={integration}
                    botSettings={integration.botSettings}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />                                  
                </Fragment>
              )}
              {apperanceVisible && (
                <Fragment>
                  <DigitalAssistant
                    isVoucher={true}
                    botSettings={integration.botSettings}
                    allProperties={allProperties}
                    propertyId={propertyId}
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  <Example url={AivaAppearanceImage} />
                </Fragment>
              )}
              {nudgesVisible && (
                <Fragment>
                  <NudgesSetting
                    integration={integration}
                    showVoucherList={showVoucherList}
                    nudges={
                      integration.channelDetails !== null
                        ? integration.channelDetails.initiationRuleset[0].nudges
                        : ''
                    }
                  />
                  <Example url={aiva_nudges} />
                </Fragment>
              )}           
              {publishVisible && (
                <VoucherCodeSnippet integration={integration} propertyId={propertyId} />
              )}
              {positionVisible && (
                <Fragment>
                  <BubblePosition
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  />
                  <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/position.png" />
                </Fragment>
              )}
              {fontsVisible && (
                <Fragment>
                  <CustomFonts
                     botSettings={integration.botSettings}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                  />
                </Fragment>
              )}
              {languageVisible && (
                <Fragment>
                  <MultliLanguages
                    botSettings={integration.botSettings}
                    saveIntegration={saveIntegration}
                  />
                  <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/languages.png" />
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Voucher));